<template>
  <div class="planbill-settings">
    <h1 class="settings-title">
      Plan + Billing
    </h1>
    <h2 class="settings-subtitle">
      Details
    </h2>
    <b-card
      body-class="planbill-card-body"
      class="card-plain planbill-card">
      <div class="planbill-info">
        <div class="settings-title">Current Plan:</div>
        <div class="settings-value">
          <p
            v-for="plan in plans"
            :key="plan"
            class="plan">{{ plan }}</p>
        </div>
      </div>
      <div class="planbill-info">
        <div class="settings-title">Billing Info: </div>
        <div class="settings-value">
          <p v-if="merchant.payment_method.type === 'invoice'">Invoice</p>
          <p v-if="merchant.payment_method.type === 'unknown'">Unknown</p>
          <p
            v-if="merchant.payment_method.type === 'card'"
            class="card-info">
            Credit card
            <span v-if="merchant.payment_method.brand"> -&nbsp;
              <img
                class="credit-card-logo"
                :src="`/static/img/cards/${cardImage}.svg`"
                alt="credit card logo">
              {{ merchant.payment_method.brand }}</span>
            <span v-if="merchant.payment_method.last4"> ending in {{ merchant.payment_method.last4 }}</span>
          </p>
        </div>
      </div>
      <hr>
      <b-form-group>
        <label class="settings-label">
          Change Card
        </label>
        <StripeCard
          ref="stripeCard"
          :public-key="stripePublishableKey"
          @handle-error="handleStripeErrors"/>
      </b-form-group>
      <div
        v-if="errorMessage"
        class="error-message">
        {{ errorMessage }}
      </div>
      <div
        v-if="showSuccessMessage"
        class="account-settings__success">
        Card is successfully updated.
      </div>
      <b-button
        :class="{loading: saving}"
        :disabled="saving"
        class="btn-round btn-save mt-4 mb-0"
        @click="prepareSubmit">
        <span v-if="!saving">Update</span>
        <div class="loader"><div class="loading-circle"/></div>
      </b-button>
    </b-card>
  </div>
</template>

<style lang="scss">
.credit-card-logo {
  height: 14px;
  vertical-align: baseline;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import StripeCard from '../../common/StripeCard';
import cardImagePath from '@/helpers/cardImage';

// paymentCardChanged
export default {
  name: 'PlanBillingSettings',
  components: {
    StripeCard,
  },
  data() {
    return {
      saving: false,
      showSuccessMessage: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      paymentCardChanged: 'user/paymentCardChanged',
      cardData: 'user/card',
      merchant: 'merchant/merchant',
      stripePublishableKey: 'system/stripePublishableKey',
    }),
    cardImage() {
      return cardImagePath(this.merchant.payment_method.brand);
    },
    plans() {
      return this.merchant.plan.split(',');
    },
  },
  watch: {
    paymentCardChanged(changed) {
      if (changed) {
        this.showSuccessMessage = true;
        this.saving = false;
        this.fetchUser();
        setTimeout(() => {
          this.showSuccessMessage = false;
        }, 1500);
      }
    },
  },
  mounted() {
    this.fetchUser();
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
      changePaymentCard: 'user/changePaymentCard',
    }),
    handleStripeErrors(error) {
      this.errorMessage = error;
      this.saving = false;
    },
    prepareSubmit() {
      this.saving = true;
      this.errorMessage = '';
      this.$refs.stripeCard.getStripeToken(this.changeCard);
    },
    changeCard() {
      this.changePaymentCard({
        card_token: this.$refs.stripeCard.token,
        business_id: this.$route.params.merchant_id,
      });
    },
  },
};
</script>
